<template>
	<div class="equipmentInstallationManagement mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">运营商管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">运营商列表</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新建运营商"></div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.serviceProviderName"
								placeholder="请输入运营商名称"></el-input>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.serviceProviderType" slot="prepend"
								placeholder="请选择运营商类型">
								<el-option v-for="(item,inx) in typeList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.serviceProviderStatus" slot="prepend"
								placeholder="请选择运营状态">
								<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号" width="70">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="serviceProviderName" label="运营商名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="linkMan" label="联系人">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="linkPhone" label="联系方式">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityNum" label="社区数量">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="equipmentNum" label="设备数量">
							</el-table-column>
							<el-table-column prop="serviceProviderType" label="运营商类型">
								<template slot-scope="scope">
									<span>{{getName(scope.row.serviceProviderType,typeList)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="serviceProviderStatus" label="状态">
								<template slot-scope="scope">
									<span>{{getName(scope.row.serviceProviderStatus,statusList)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operate" label="操作" width="180">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">基本信息</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">分账配置</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,3)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营商名称" prop="serviceProviderName">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.serviceProviderName" placeholder="请输入运营商名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="联系人" prop="linkMan">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.linkMan" placeholder="请输入联系人">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="联系方式" prop="linkPhone">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.linkPhone" maxlength="11"
										placeholder="请输入联系方式">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营状态" prop="serviceProviderStatus">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.serviceProviderStatus" slot="prepend"
										placeholder="请选择运营状态">
										<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营商类型" prop="serviceProviderType">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.serviceProviderType" slot="prepend"
										placeholder="请选择运营商类型">
										<el-option v-for="(item,inx) in typeList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="省市区" prop="areaValue">
								<div class="myinputBox myinputBox2">
									<el-cascader clearable v-model="creatObj.areaValue" ref="cascader2"
										:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}"
										:options="areaList" @change="handleChange($event,2)"></el-cascader>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem  disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="具体地址" prop="address">
								<div class="myinputBox myinputBox2">
									<el-input clearable id="userInput" @focus='openaddress=true'
										v-model="creatObj.address" placeholder="请输入具体地址 / 社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="资质材料" prop="file">
								<div class="myinputBox myinputBox3">
									<el-upload class="upload-demo" :auto-upload="autoUpload" :on-change="getFile"
										action="certmanage" :http-request="httpRequest" :on-preview="handlePreview"
										:on-remove="handleRemove" :before-remove="beforeRemove"
										:before-upload="beforeUpload" :limit="1" :on-exceed="handleExceed"
										:file-list="fileList" :on-success="onSuccess">
										<el-button size="small" type="primary">点击上传</el-button>
										<div slot="tip" class="el-upload__tip">请上传格式为rar、zip等格式的压缩包</div>
									</el-upload>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem  diaItem2 disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="我的团队">
								<div class="myinputBox myinputBox2 disStart">
									<div v-for="(item,inx) in creatObj.userInfoList" :key="inx"
										class="inputItemBox boxShaw">
										<div class="valueBox">{{item.userName||"姓名"}}</div>
										<div class="valueBox">{{item.phone}}</div>
										<span class="delIcon" @click="deltetAct(item,inx)"></span>
									</div>
									<span class="addIcon " v-if="creatObj.userInfoList.length<5"
										@click="addTeam"></span>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm3')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :title="titleName" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="visibleShow" width="50%">
			<el-form :model="accountsObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="分账方式">
								<div class="myinputBox">
									<el-radio-group v-model="accountsObj.divideAccountType" disabled>
										<el-radio label="1">利润</el-radio>
										<el-radio label="2">流水</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="分账比例" prop="divideAccountProportion">
								<div class="myinputBox">
									<el-input clearable v-model="accountsObj.divideAccountProportion"
										placeholder="请输入分账比例">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="结算周期" prop="settlementCycle">
								<div class="myinputBox ">
									<!-- <div class="myinputBox " :class="{disBetween:accountsObj.settlementCycle==4}"> -->
									<el-radio-group v-model="accountsObj.settlementCycle">
										<el-radio label="5">日</el-radio>
										<el-radio label="1">周</el-radio>
										<el-radio label="2">半月</el-radio>
										<el-radio label="3">月</el-radio>
										<el-radio label="4">季度</el-radio>
									</el-radio-group>
									<!-- <el-input class="smallInput" v-if="accountsObj.radio2==4" clearable
										v-model="accountsObj.initializeEquipmentNum" placeholder="请输入分账比例">
									</el-input> -->
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="打款时间" prop="payTimeType">
								<div class="myinputBox">
									<el-radio-group v-model="accountsObj.payTimeType">
										<el-radio label="1">T+1</el-radio>
										<el-radio label="2">T+3</el-radio>
										<el-radio label="3">次月10号</el-radio>
										<el-radio label="4">次月15号</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="打款方式" prop="payType">
								<div class="myinputBox">
									<el-radio-group v-model="accountsObj.payType">
										<el-radio label="1">微信账户</el-radio>
										<el-radio label="2">银联(私人)</el-radio>
										<el-radio label="3">银联(对公账户)</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="账户号" prop="accountNumber">
								<div class="myinputBox">
									<el-input clearable v-model="accountsObj.accountNumber" placeholder="请输入账户号">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="accountsObj.payType==2||accountsObj.payType==3">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属银行" prop="accountBank">
								<div class="myinputBox">
									<el-input clearable v-model="accountsObj.accountBank" placeholder="请输入所属银行">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="添加成员" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow1"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm5" label-width="100px" class="demo-ruleForm">
				<div class=" dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="用户姓名" prop="userName">
								<div class="myinputBox">
									<el-input v-model="creatObj.userName" type="text" placeholder="请输入用户姓名">
										<template slot="append"></template></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="用户账号" prop="linkPhone2">
								<div class="myinputBox">
									<el-input v-model="creatObj.linkPhone2" type="text" placeholder="请输入用户账号"
										oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
								</div>
							</el-form-item>
						</div>
					</div>

				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow1=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm5')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import { log10 } from "core-js/core/number"
import {
		timestampToDate
	} from "../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "accountManage",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				headers: {
					Authorization: token,
					token: token
				},
				autoUpload: false,
				creatObj: {
					serviceProviderName: "",
					serviceProviderType: "",
					serviceProviderStatus: "",
					linkMan: "",
					linkPhone: "",
					provinceCode: "",
					cityCode: "",
					areaCode: "",
					address: "",
					file: "",
					userInfoList: [],
					linkPhone2: "",
				},
				accountsObj: {
					serviceProviderId: "",
					divideAccountType: 0, //0未选择 1利润 2流水
					divideAccountProportion: null, //分账比例
					settlementCycle: 0, //结算周期 0未选 1周 2半月 3月 4季度
					payTimeType: 0, //间类型 0未选 1T+1  2T+3 3次月10号 4次月15号
					payType: 0, //打款方式 0未选 1微信支账户 2银联（私人） 3银联（对公账户）
					accountNumber: null, //账户号
					accountBank: null //账户银行
				},
				dialogVisible: false,
				visibleShow: false,
				visibleShow1: false,
				NOfalse: false,
				dialogTitle: "新建运营商",
				typeList: [{
						text: "直营商",
						value: 1
					},
					{
						text: "承包商",
						value: 2
					},
					{
						text: "第三方",
						value: 3
					},
				],
				statusList: [{
						text: "未运营",
						value: 1
					},
					{
						text: "已运营",
						value: 2
					},
				],
				tableData: [],
				areaList: [],
				fileList: [],
				loading: false,
				searchObj: {
					serviceProviderName: "", //
					serviceProviderName: "",
					serviceProviderType: "",
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
				},
				rules: {
					serviceProviderName: [{
						required: true,
						message: '请输入运营商名称',
						trigger: 'blur'
					}],
					linkMan: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					linkPhone: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}],
					userName: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					linkPhone2: [{
						required: true,
						message: '请输入用户账号',
						trigger: 'blur'
					}],
					serviceProviderType: [{
						required: true,
						message: '请选择运营商类型',
						trigger: 'change'
					}],
					serviceProviderStatus: [{
						required: true,
						message: '请选择运营状态',
						trigger: 'change'
					}],
					areaValue: [{
						required: true,
						message: '请选择省市区',
						trigger: 'change'
					}],
					address: [{
						required: true,
						message: '请输入具体地址 / 社区名称',
						trigger: 'blur'
					}],
					divideAccountProportion: [{
						required: true,
						message: '请输入分账比例',
						trigger: 'blur'
					}],
					settlementCycle: [{
						required: true,
						message: '请选择结算周期',
						trigger: 'change'
					}],
					payTimeType: [{
						required: true,
						message: '请选择打款时间',
						trigger: 'change'
					}],
					payType: [{
						required: true,
						message: '请选择打款方式',
						trigger: 'change'
					}],
					accountNumber: [{
						required: true,
						message: '请输入账户号',
						trigger: 'blur'
					}],
					accountBank: [{
						required: true,
						message: '请输入所属银行',
						trigger: 'blur'
					}],
				},
				titleName: "分账配置",
				fd: new FormData()
			}
		},
		mounted() {
			if (!(localStorage.getItem("areaList"))) {
				this.getAreaList()
			} else {
				this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
			}
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			deltetAct(item, inx) {
				this.creatObj.userInfoList.splice(inx, 1)
			},
			addTeam() {
				this.$set(this.creatObj, "linkPhone2", "")
				this.$set(this.creatObj, "userName", "")
				this.visibleShow1 = true
				this.$nextTick(() => {
					this.$refs.ruleForm5.clearValidate()
				})
			},
			getFile(file, fileList) {
				this.fileList = fileList;
				let extName = file.name.substring(file.name.lastIndexOf('.') + 1);
				var AllUpExt = '.rar|.zip|.pem|'
				if (AllUpExt.indexOf(extName) === -1) {
					this.$message.error('文件格式不正确!')
					// this.isDisable = true; //校验不正确不允许表单提交
					this.fileList = []
				} else {
					console.log(file)
					console.log(this.fileList)
					this.fd.append('file', file.raw)
				}
			},
			httpRequest(param) {
				console.log(param)
				console.log(this.fd)
				console.log(this.fileList)
				const fileObj = param.file // 相当于input里取得的files
				console.log(fileObj)
				this.fd.append('file', fileObj)
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeUpload(file) {
				let type = file.name.slice(file.name.lastIndexOf(".") + 1)
				if (type == "rar" || type == "zip") {

				} else {
					this.$message.warning(`请上传格式为rar、zip等格式的压缩包`);
					return false
				}
			},
			onSuccess(response, file, fileList) {

			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`已经上传资质材料`);
			},
			beforeRemove(file, fileList) {
				// return this.$confirm(`确定移除 ${ file.name }？`);
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {

					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			numberChange(val, maxNum, ) {
				//转换数字类型
				let num = Number(val)
				if (num < 0) {
					this.$set(this.creatObj, "initializeEquipmentNum", 0)
				}
				if (num > 50) {
					this.$set(this.creatObj, "initializeEquipmentNum", 50)
				}
			},
			// changeEnd
			selectParamConfigByCode() {
				this.$api.selectParamConfigByCode({
					"paramCode": 1002,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						for (let k of res.obj.paramConfigItemList) {
							this.restaurants.push({
								value: k.paramConfigItemName,
								id: k.paramConfigItemId
							})
						}

					}
				})

			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			exportData() {
				let obj = {
					serviceProviderName: this.searchObj.serviceProviderName,
					serviceProviderType: this.searchObj.serviceProviderType,
					serviceProviderStatus: this.searchObj.serviceProviderStatus,
				}
				this.$api.exportServiceProvider(obj, "运营商列表").then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				console.log(this.fileList)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm3") {
							console.log(33333);
							if (this.dialogTitle == "新建运营商") {
								if (this.fileList.length > 0) {
									console.log('添加');
									// that.$api.addServiceProvider(this.creatObj).then((res)=>{
									// 		console.log(res)
									// 	})
									that.addServiceProvider()
								} else {
									this.$message({
										message: "请上传运营商资质材料",
										type: 'error'
									});
								}
							} else {

								that.updateServiceProvider()
							}

						} else if (formName == "ruleForm4") {
							
							that.$api.updateAccountConfig(this.accountsObj).then((res) => {
								if (res.returnCode == 200) {
									that.visibleShow = false
									that.getData()
								}
							})
						} else if (formName == "ruleForm5") {
							that.$api.listUserInfoByPhone({
								phone: this.creatObj.linkPhone2
							}).then((res) => {
								if (res.returnCode == 200) {
									let obj = this.creatObj.userInfoList.find((item, inx) => {
										return item.phone == res.obj.phone
									})
									if (obj) {
										this.$message({
											message: '已添加该成员!',
											type: "info"
										});
										return false
									} else {
										this.$set(res.obj, "userName", this.creatObj.userName)
										this.creatObj.userInfoList.push(res.obj)
										that.visibleShow1 = false
									}
								}
							})
						}

					} else {
						return false;
					}
				});

			},
			updateServiceProvider() {
				let arr1 = []
				let arr2 = []
				for (let k of this.creatObj.userInfoList) {
					arr1.push(k.loginId)
					arr2.push(k.userName)
				}
				let str1 = arr1.join(",")
				let str2 = arr2.join(",")
				// for (let i = 0; i < this.creatObj.userInfoList.length; i++) {
				//     this.fd.append("userInfoList[" + i + "].loginId", this.creatObj.userInfoList[i].loginId);
				//     this.fd.append("userInfoList[" + i + "].userName", this.creatObj.userInfoList[i].userName||"姓名");
				// }
				this.fd.append("serviceProviderName", this.creatObj.serviceProviderName)
				this.fd.append("linkMan", this.creatObj.linkMan)
				this.fd.append("linkPhone", this.creatObj.linkPhone)
				this.fd.append("serviceProviderStatus", this.creatObj.serviceProviderStatus)
				this.fd.append("serviceProviderType", this.creatObj.serviceProviderType)
				this.fd.append("provinceCode", this.creatObj.provinceCode)
				this.fd.append("cityCode", this.creatObj.cityCode)
				this.fd.append("areaCode", this.creatObj.areaCode)
				this.fd.append("serviceProviderId", this.creatObj.serviceProviderId)
				this.fd.append("address", this.creatObj.address)
				this.fd.append("loginIdList", str1)
				this.fd.append("userNameList", str2)
				this.$api.updateServiceProvider(this.fd).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '编辑运营商成功',
								type: 'success'
							});
							setTimeout(() => {
								// 刷新社区列表 和充电站   
								this.getData()
							}, 500)
						})
					}
				})
			},
			// 设备新增请求
			addServiceProvider() {
				let arr1 = []
				let arr2 = []
				for (let k of this.creatObj.userInfoList) {
					arr1.push(k.loginId)
					arr2.push(k.userName)
				}
				let str1 = arr1.join(",")
				let str2 = arr2.join(",")
				// for (let i = 0; i < this.creatObj.userInfoList.length; i++) {
				//     this.fd.append("userInfoList[" + i + "].loginId", this.creatObj.userInfoList[i].loginId);
				//     this.fd.append("userInfoList[" + i + "].userName", this.creatObj.userInfoList[i].userName);
				// }
				this.fd.append("serviceProviderName", this.creatObj.serviceProviderName)
				this.fd.append("linkMan", this.creatObj.linkMan)
				this.fd.append("linkPhone", this.creatObj.linkPhone)
				this.fd.append("serviceProviderStatus", this.creatObj.serviceProviderStatus)
				this.fd.append("serviceProviderType", this.creatObj.serviceProviderType)
				this.fd.append("provinceCode", this.creatObj.provinceCode)
				this.fd.append("cityCode", this.creatObj.cityCode)
				this.fd.append("areaCode", this.creatObj.areaCode)
				this.fd.append("address", this.creatObj.address)
				this.fd.append("loginIdList", str1)
				this.fd.append("userNameList", str2)
				this.$api.addServiceProvider(this.fd).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新建运营商成功',
								type: 'success'
							});
							setTimeout(() => {
								// 刷新社区列表 和充电站   
								this.getData()
							}, 500)
						})
					}
				})
			},
			selectAccountConfig(item) {

				this.$set(this.accountsObj, "serviceProviderId", item.serviceProviderId)
				if (item.serviceProviderType == 1) {
					this.titleName = "分账配置(直营商)"
					this.$set(this.accountsObj, "divideAccountType", "1")
				} else {
					this.titleName = "分账配置(第三方/承包商)"
					this.$set(this.accountsObj, "divideAccountType", "2")
				}
				this.$api.selectAccountConfig({
					serviceProviderId: item.serviceProviderId
				}).then((res) => {
					if (res.returnCode == 200) {
						this.visibleShow = true
						this.$set(this.accountsObj, "divideAccountProportion", res.obj.divideAccountProportion)
						this.$set(this.accountsObj, "settlementCycle", res.obj.settlementCycle + "")
						this.$set(this.accountsObj, "payTimeType", res.obj.payTimeType + "")
						this.$set(this.accountsObj, "payType", res.obj.payType + "")
						this.$set(this.accountsObj, "accountNumber", res.obj.accountNumber)
						this.$set(this.accountsObj, "accountBank", res.obj.accountBank)
						this.$nextTick(() => {
							this.$refs.ruleForm4.clearValidate()
						})
					}
				})
			},
			bindAct(item) {
				let obj = {
					phone: 18351909003
				}
				this.$api.listUserInfoByPhone(obj).then((res) => {
					if (res.returnCode == 200) {
						let dataOj = {
							loginId: res.obj.loginId,
							serviceProviderId: item.serviceProviderId
						}
						this.bindUser(dataOj)
					}
				})
			},
			bindUser(obj) {
				console.log(obj)
				this.$api.bindUser(obj).then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			// 1编辑2运维记录3设备二维码4删除
			itemClick(item, n) {
				this.fileList = []
				let that = this
				if (n == 1) {
					// this.bindAct(item)
					this.dialogTitle = "运营商信息"
					let arr = []
					for (let k in item.loginIdList) {
						arr.push({
							userName: item.userNameList[k],
							phone: item.phoneList[k],
							loginId: item.loginIdList[k],
						})
					}
					this.$set(this, "creatObj", {
						serviceProviderName: item.serviceProviderName,
						serviceProviderId: item.serviceProviderId,
						serviceProviderType: item.serviceProviderType,
						serviceProviderStatus: item.serviceProviderStatus,
						linkMan: item.linkMan,
						linkPhone: item.linkPhone,
						provinceCode: item.provinceCode,
						cityCode: item.cityCode,
						areaValue: [],
						areaCode: item.areaCode,
						address: item.address,
						file: item.file,
						userInfoList: arr,
					})
					if (item.provinceCode) {
						this.creatObj.areaValue.push(item.provinceCode)
						if (item.cityCode) {
							this.creatObj.areaValue.push(item.cityCode)
							if (item.areaCode) {
								this.creatObj.areaValue.push(item.areaCode)
							}
						}
					}
					if (item.fileName) {
						this.fileList.push({
							name: item.fileName,
							percentage: " ",
							raw: "",
							size: "",
							status: "",
							uid: ""
						})
					}

					this.dialogVisible = true
				} else if (n == 2) {
					this.selectAccountConfig(item)
				} else if (n == 3) {
					this.$confirm('是否确认删除该运营商?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteServiceProvider({
							serviceProviderId: item.serviceProviderId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									this.getData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 5) {
					this.dialogTitle = "新建运营商"
					this.$set(this, "creatObj", {
						serviceProviderName: "",
						serviceProviderType: "",
						serviceProviderStatus: "",
						linkMan: "",
						linkPhone: "",
						provinceCode: "",
						cityCode: "",
						areaCode: "",
						address: "",
						file: "",
						userInfoList: []
					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm3.clearValidate()
					})
				}
			},
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData() {
				this.loading = true
				let obj = {
					serviceProviderName: this.searchObj.serviceProviderName, //社区编号
					serviceProviderType: this.searchObj.serviceProviderType,
					serviceProviderStatus: this.searchObj.serviceProviderStatus,
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
				}
				this.$api.listServiceProvider(obj).then((res) => {
					// console.log(res,6666666)
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})

			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData()
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.creatObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.creatObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.creatObj, "areaCode", nodesInfo[0].path[2] || "")
				}
			},
		},
		
	}
</script>

<style lang="scss" scoped>
	@import "./operatorManagement.scss";
</style>